import { LogInResponse } from '@api/Auth';
import { CelebrityResponse } from '@api/Celebrities';
import Joi from 'joi';

export type TNotifyMeForm = {
  email: string;
};

export const NotifyMeForm = Joi.object<TNotifyMeForm>({
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .required(),
});

export interface ProfileFormProps {
  celebrityInfo: CelebrityResponse;
  user: LogInResponse | null;
}
